import { faChevronLeft, faChevronRight, faSearchPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Props } from 'mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage';
import {
    strollersDetailUrl,
    strollersDetailVariantUrl,
    strollersPhotoUrl,
    strollersVariantPhotoUrl,
} from 'mk2/apps/strollers/urls';
import { ImageGalleryLoadable } from 'mk2/components/ImageGalleryLoadable';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { NotFound } from 'mk2/components/NotFound';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './StrollerProductPhoto.mscss';
import './StrollerProductPhoto.scss';

export class StrollerProductPhoto extends React.Component<Props> {

    public componentDidMount() {
        const { onCheckHideThumbnails } = this.props;
        if (typeof window !== 'undefined') {
            // run on mount if not SSR
            onCheckHideThumbnails();
        }
    }

    public render() {
        const { loadingState } = this.props;

        return (
            <div className={styles.StrollerProductPhoto}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={false}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const {
            strollerSlug, strollerVariantId, images, photoId, staticContext, match, location, history, hideThumbnails, thumbsKey,
        } = this.props;

        const image = images.find((i) => i.id === photoId);
        if (!image) {
            return (
                <NotFound
                    match={match}
                    location={location}
                    history={history}
                    staticContext={staticContext}
                    backUrl={!!strollerVariantId ? url(strollersDetailVariantUrl, { slug: strollerSlug, variantId: strollerVariantId })
                        : url(strollersDetailUrl, { slug: strollerSlug })}
                />
            );
        }

        const currentIndex: number = images.findIndex((p) => p.id === image.id);
        const showThumbnails = !hideThumbnails;

        return (
            <div className={styles.StrollerProductPhoto__gallery}>
                {/* when changing showThumbnails, ImageGalleryLoadable need to be re-rendered */}
                {hideThumbnails !== null ? (
                    <ImageGalleryLoadable
                        key={`gal-thumbs-${thumbsKey}`}
                        items={images}
                        showIndex
                        showThumbnails={showThumbnails}
                        thumbnailPosition={showThumbnails ? 'top' : undefined}
                        autoPlay={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        slideDuration={500}
                        startIndex={currentIndex}
                        onSlide={this.onSlide}
                        renderLeftNav={this.renderLeftNav}
                        renderRightNav={this.renderRightNav}
                        renderCustomControls={this.renderCustomControls}
                    />
                ) : <LoadingPlaceholder width="100%" height={600} />}
            </div>
        );
    };

    private renderLeftNav = (onClick, disabled) => {
        return (
            <div key="prev" className={styles.StrollerProductPhoto__prev} onClick={disabled ? undefined : onClick}>
                <FontAwesomeIcon icon={faChevronLeft} className={styles.StrollerProductPhoto__prev__icon} />
            </div>
        );
    };

    private renderRightNav = (onClick, disabled) => {
        return (
            <div key="next" className={styles.StrollerProductPhoto__next} onClick={disabled ? undefined : onClick}>
                <FontAwesomeIcon icon={faChevronRight} className={styles.StrollerProductPhoto__next__icon} />
            </div>
        );
    };

    private renderCustomControls = () => {
        const { photoId, images } = this.props;
        const image = images.find((p) => p.id === photoId);
        const showMagnifier = Boolean(image.fullSizeUrl);
        const showControls = showMagnifier;

        if (!showControls) {
            return null;
        }

        return (
            <div className={styles.StrollerProductPhoto__controls}>
                {showMagnifier && (
                    <a
                        data-google-interstitial="false"
                        key="magnifier"
                        href={image.fullSizeUrl}
                        target="_blank"
                        className={styles.StrollerProductPhoto__controls__control}
                    >
                        <FontAwesomeIcon icon={faSearchPlus} />
                    </a>
                )}
            </div>
        );
    };

    private onSlide = (currentIndex: number) => {
        const {
            history,
            images,
            strollerVariantId,
            match: { params },
        } = this.props;
        const image = images[currentIndex];
        const gotoUrl = !!strollerVariantId ? url(strollersVariantPhotoUrl, {
                slug: params.slug,
                variantId: strollerVariantId,
                photoId: image.id,
            })
            : url(strollersPhotoUrl, {
                slug: params.slug,
                photoId: image.id,
            });
        history.replace({
            pathname: gotoUrl,
        });
    };

    private load = () => {
        const { strollerSlug, strollerVariantId, onLoad } = this.props;

        if (!!strollerVariantId) {
            onLoad(strollerSlug, strollerVariantId);
        } else {
            onLoad(strollerSlug);
        }
    };
}
